import Sclerals from './Sclerals';

export default Sclerals;